import api from './api';

export const userService = {
  getAllUsers: (params) => api.get('/users', { params }),
  createUser: (data) => api.post('/users', data),
  getActiveDJs: () => api.get('/users/active-djs'),
  getUserById: (id) => api.get(`/users/${id}`),
  updateUser: (id, data) => api.put(`/users/${id}`, data),
  deleteUser: (id) => api.delete(`/users/${id}`),
  approveUser: (id) => api.put(`/users/${id}/approve`),
  updateUserStatus: (id, status) => api.put(`/users/${id}/status`, { status }),
  updateProfile: (data) => api.put('/auth/profile', data),
  uploadProfilePhoto: (formData) => api.post('/auth/profile/photo', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  }),

  // Chat Backgrounds
  uploadChatBackground: (index, formData) => api.post(`/users/chat-background/${index}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  }),
  toggleChatActive: () => api.post('/users/chat-background-toggle'),
  removeChatBackground: (index) => api.delete(`/users/chat-background/${index}`),
};
